import React from 'react';
import PropTypes from 'prop-types';
import Image from 'react-bootstrap/lib/Image';
import classnames from 'classnames';
import Utils from '../Utils';
import Classes from '../Classes';

const ProducerImage = ({
  src, alt, onClick, imageSize, deviceType, tag, isRounded, producerId, defaultArtistLogoUrl
}) => {
  const imageUrl = src ? Utils.getResizedImage(src, deviceType, imageSize) : defaultArtistLogoUrl;
  const clickable = onClick ? Classes.clickable : null;

  return (
    <div className={Classes.relative}>
      <Image
        responsive
        className={classnames(Classes.centerBlock, clickable, { [Classes.roundCorners]: isRounded })}
        src={imageUrl}
        data-dtm={tag}
        data-dtm-attributes={JSON.stringify({ producerId })}
        alt={alt}
        onClick={onClick}
      />
    </div>
  );
};

ProducerImage.propTypes = {
  src: PropTypes.string,
  imageSize: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  alt: PropTypes.string,
  producerId: PropTypes.string,
  tag: PropTypes.string,
  onClick: PropTypes.func,
  isRounded: PropTypes.bool,
  defaultArtistLogoUrl: PropTypes.string
};

export default ProducerImage;
